import React, { useEffect, useState } from 'react'
import { Box, SwipeableDrawer, IconButton, Tooltip } from '@mui/material'
import * as OnboardEntity from '../../../Entities/OnBoardingContainerTypes'
import { useForm } from 'react-hook-form'
import Textarea from 'src/Common/ui/textArea'
import { cn, inputValidation } from 'src/lib/utils'
import { Button } from 'src/Common/ui/button'
import { t } from 'i18next'
import { IoIosCloseCircleOutline } from 'react-icons/io'

export default function ComplianceCommentsDrawer ({ setEditState, handleReject, editState, comments, setComments }) {
    const [ getComments, setGetComments ] = useState(null)
    const { control, handleSubmit, formState: { errors, isLoading, isSubmitting }, setValue } = useForm({ mode: 'onChange' })
    useEffect(() => {
        setGetComments(comments)
        setValue('compliance-comment', comments)
    }, [comments])
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    const onInputChange = (e) => {
        setComments(e)
    }
    const handleCancel = () => {
        setEditState({ right: false })
        setComments('')
    }
    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <Box className="p-4 flex justify-between items-center border-b-2 border-[hsl(var(--primary-table-head))]">
                    <h2 className='text-primary font-semibold'>Reject</h2>
                    <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={() => handleCancel()} aria-label="close">
                            <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                        </IconButton>
                    </Tooltip>
                </Box>
                <div className='p-4'>
                    <Textarea required={true} className={cn('ml-[0px] text-muted')} label="Comments" value={getComments}
                        onValueChange={(e) => onInputChange(e)}
                        rules={{
                            required: true,
                            validate: (value) => {
                                return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                            }
                        }}
                        defaultValue={getComments} type="text" placeholder="Enter Comments" name="compliance-comment" errors={errors} control={control} maxLength={250}/>
                </div>

                <div className='absolute bottom-[16px] right-[20px]'>
                    <div className="flex justify-end space-x-4">
                        <Box>
                            <Button onClick={() => handleCancel()}
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            >
                         Cancel
                            </Button>
                        </Box>
                        <Box>
                            <Button onClick={() => handleSubmit(handleReject('reject'))}
                                disabled={isLoading || isSubmitting}
                            >
                         Submit
                            </Button>
                        </Box>
                    </div>
                </div>
                <div className='p-4 flex flex-col gap-3'>

                </div>

            </SwipeableDrawer>
        </div>
    )
}
